'use client'

import { useEffect } from 'react'

import {
  PricingRulesModel,
  viewEvent,
  CatalogModel,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { CountryModel } from '@marketplace-web/country/country-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import IntroductionSection from './IntroductionSection'
import PriceRuleSection from './PriceRuleSection'
import AdditionalInformationSection from './AdditionalInformationSection'

type Props = {
  priceRules: PricingRulesModel
  countries?: Array<CountryModel> | null
  catalogs?: Array<CatalogModel>
}

const AvailableDiscountLandingPage = ({ priceRules, countries, catalogs }: Props) => {
  const { track } = useTracking()

  const targetDetails = JSON.stringify({
    campaign_name: priceRules.map(rule => rule.name),
  })

  useEffect(() => {
    track(
      viewEvent({
        screen: 'campaign_landing_page',
        target: 'campaign_landing_page',
        targetDetails,
      }),
    )
  }, [track, targetDetails])

  return (
    <div className="available_discounts__landing-page">
      <div className="available_discounts__landing-page-container">
        <IntroductionSection />
        <div>
          {priceRules.map(priceRule => (
            <PriceRuleSection
              key={priceRule.id}
              priceRule={priceRule}
              countries={countries}
              catalogs={catalogs}
            />
          ))}
        </div>
        <AdditionalInformationSection priceRules={priceRules} />
      </div>
    </div>
  )
}

export default AvailableDiscountLandingPage
